var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"lottie",staticClass:"lottie-animation",class:{ shadow: _vm.options.shadow, 'play-on-scroll': _vm.playOnScroll },style:(_vm.style)})
}
var staticRenderFns = []

export { render, staticRenderFns }